module.exports = __webpack_public_path__ + "img/file-type-ppt.5ed48aa4.svg";